import React from "react";
import { ArrowRight, Mail } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Hero() {
  const {
    ref: contentRef,
    isVisible: isContentVisible
  } = useRevealOnScroll();
  return <section data-section-id="39597" id="hero-introduction" className="relative w-full min-h-[80vh] flex flex-col lg:grid lg:grid-cols-5 bg-[#F8F7F4] text-[#2D2D2D]">
      {}
      <div className="lg:col-span-3 bg-[#F8F7F4] text-[#2D2D2D] flex flex-col justify-center px-8 py-14 lg:px-24 lg:py-20 order-2 lg:order-1">
        <div ref={contentRef} className={`max-w-2xl transition-all duration-1000 ease-out ${isContentVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
          <h1 className="font-serif text-[#1B2A4A] text-4xl md:text-5xl lg:text-[72px] font-medium leading-tight tracking-tight mb-6">
            Growth You Own: Strategic Excellence Co-Designed
          </h1>
          <p className="font-sans text-lg md:text-xl text-[#2D2D2D] mb-10 leading-[1.6] max-w-xl">
            Build lasting internal capability with a collaborative approach to organizational growth. We partner with you to design strategies that empower your vision and drive sustainable results.
          </p>
          
          <div className="flex flex-col sm:flex-row gap-4">
            <Button asChild className="bg-[#1B2A4A] text-white hover:bg-[#E8A838] border-none rounded-none px-8 py-6 text-base font-semibold shadow-lg transition-colors duration-300">
              <Link to="/ServicesPage">
                Our Services
                <ArrowRight className="ml-2 h-5 w-5" />
              </Link>
            </Button>
            
            <Button asChild variant="outline" className="bg-transparent border-[#1B2A4A] text-[#1B2A4A] hover:bg-[#1B2A4A]/5 hover:text-[#1B2A4A] rounded-none px-8 py-6 text-base font-semibold transition-colors duration-300">
              <Link to="/ScheduleYourStrategySessionPage">
                <Mail className="mr-2 h-5 w-5" />
                Schedule a Session
              </Link>
            </Button>
          </div>
        </div>
      </div>

      {}
      <div className="lg:col-span-2 relative min-h-[400px] lg:min-h-full order-1 lg:order-2">
        <div className="absolute inset-0 bg-[#2A7F7F]/10 z-10" /> {}
        <div className="absolute inset-0 bg-cover bg-center bg-no-repeat bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1443870/img/modern_collaborative_workspace.png)]" aria-hidden="true" />
      </div>
    </section>;
}